import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import { Checkbox, Divider, FormGroup } from "@mui/material";
import { useContext } from "react";
import EventContext from "../store/event-context";
import appTheme from '../appTheme'
import { ThemeProvider } from '@mui/material/styles'

// ToDo:
//
// - Check whole email example (i.e. button and popover?)
// - Logo
// - Backend / API:
//      - Change current Event data to the background database (local value is done!)

const EventUpdate = () => {

    const eventctx = useContext(EventContext);
    //console.log("Event: ", eventctx.event);

    // For the input field we need format YYYY-MM-DD
    // And for the actual content of the date we want the local format, so turn the format during this form
    //
    const turnDate = (date) => {
        const hlpArr = date.split('-');
        return (hlpArr.reverse()).join('-');
    }

    let hlpDate = eventctx.event.date;
    const hlpArr = hlpDate.split('-');
    if (hlpArr.length === 3 && hlpArr[2].length === 4) {
        hlpDate = turnDate(hlpDate);
    }
    //console.log("Date after: ", hlpDate);

    const defaultValues = {
        name: eventctx.event.name,
        location: (eventctx.event.location || ""),
        date: (hlpDate || ""),
        email: eventctx.event.email,
        group: eventctx.event.group,
        colors: (eventctx.event.colors || []),
        emailText: (eventctx.event.emailText || ""),
        emailSignature: (eventctx.event.emailSignature || ""),
        logo: (eventctx.event.logo || ""),
    }

    const [formValues, setFormValues] = useState(defaultValues);

    const colorSet = ["blauw", "oranje", "rood", "groen", "geel", "roze", "bruin", "zwart", "wit" ];
    const colorEng = ["blue", "orange", "red", "green", "yellow", "pink", "brown", "black", "white"];
    const colorArray = colorSet.map((code, index) => ({
        color: code,
        active:(eventctx.event.colors.some(elem => (elem === code || elem === colorEng[index] )))
    }));
    //console.log("ColorArray: ", colorArray);
    //console.log("Event colors: ", eventctx.event.colors);
    const [colorState, setColorState] = useState(colorArray);
    //console.log("ColorState: ", colorState);

    const handleInputChange = (e) => {
        const { name, value, type, checked} = e.target;
        //console.log("Handle change", type, name, value, checked)
        setFormValues({
            ...formValues,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleColorChange = (event) => {
        const newColorState = colorState.map((item) => {
            if (item.color === event.target.name) {
                item.active = event.target.checked
            }
            return item;
        });
        setColorState(newColorState);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const activeColors = colorState.filter(item => item.active);
        const newColors = activeColors.map((item) => {
            return colorEng[colorSet.indexOf(item.color)];
        });
        let newEvent = eventctx.event;
        newEvent.name = formValues.name;
        newEvent.location = formValues.location;
        newEvent.date = turnDate(formValues.date);
        newEvent.colors = newColors;
        newEvent.emailText = formValues.emailText;
        newEvent.emailSignature = formValues.emailSignature;
        console.log("Hier komt nog de goede backend verwerking...",newEvent);
        eventctx.setEvent(newEvent);
    }

    return (
        <ThemeProvider theme={appTheme}>
        <Box id="EventUpdateFormBox" component="form" autoComplete="off" onSubmit={handleSubmit} sx={{marginTop: '16px', width: '90%'}}>
            <Grid container id="EventUpdateFormContainer" direction="column" justifyContent='flex-start' spacing={1} alignItems='stretch' sx={{pl: 1}}>
                <Grid item id="Item-EventId">
                    <Typography component='span' variant="h5" color="textPrimary" sx={{pt: 1}}>{eventctx.event.eventid}</Typography>
                </Grid>
                <Grid item id="Item-URL-value">
                    <Grid container direction='row' columns={10}>
                        <Grid item xs={7}><Typography component='div' color="text.disabled" >{eventctx.event.url}</Typography></Grid>
                        <Grid item xs={3}><Typography color="text.disabled" >(Cognito-grp: {eventctx.event.group})</Typography></Grid>
                    </Grid>
                    <Divider sx={{mt: '10px'}} />
                </Grid>
                <Grid item id="Item-NameLocationDate" sx={{ mt: -1}}>
                    <Grid container direction='row' columns={10} justifyContent='space-between' alignItems='flex-start'>
                        <Grid item xs={7}>
                            <Grid container direction='column' justifyContent='flex-start' spacing={1} alignItems='stretch'>
                                <Grid item id="Item-EventName">
                                    <TextField
                                        id="Input-EventName"
                                        name="name"
                                        label="Event"
                                        type="text"
                                        variant="standard"
                                        required
                                        value={formValues.name}
                                        onChange={handleInputChange}
                                        sx={{ width: '70%', backgroundColor: 'common.white'}}
                                    />
                                </Grid>
                                <Grid item id="Item-Location">
                                    <TextField
                                        id="Input-Location"
                                        name="location"
                                        label="Locatie"
                                        type="text"
                                        variant="standard"
                                        required
                                        value={formValues.location}
                                        onChange={handleInputChange}
                                        sx={{ width: '70%', backgroundColor: 'common.white'}}
                                    />
                                </Grid>
                                <Grid item id="Item-Date">
                                    <TextField
                                        id="Input-Date"
                                        name="date"
                                        label="Datum"
                                        type="date"
                                        variant="standard"
                                        required
                                        value={formValues.date}
                                        onChange={handleInputChange}
                                        sx={{ backgroundColor: 'common.white' }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={3}>
                            <div><img  src="./stfc-logo-200.png" alt="Swim to Fight Cancer logo" width="120" height="120"/></div>
                            <Button id="LogoButton" color='primary' >Wijzig logo</Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item id="Item-Group-Colors" sx={{ mt: -2, width: '90%'}}>
                    <FormLabel sx={{ color: 'text.primary'}}>Welke batmutskleuren worden gebruikt?</FormLabel>
                    <FormGroup aria-label="color" row>
                        {colorSet.map((code, index) => (
                        <FormControlLabel key={code} sx={{ marginRight: '28px'}} 
                                 control={<Checkbox 
                                    checked={colorState.find(element => element.color === code).active}
                                    onChange={handleColorChange}
                                    name={code}
                                    sx={{
                                        color: 'text.secondary',
                                        '&.Mui-checked': {
                                        color: 'text.secondary',
                                        }, pr: '2px',
                                    }} />} 
                                label={ <Typography sx={{ backgroundColor: 'capColorBackground.'+code, color: 'capColorText.'+code, px: '4px'}}>
                                {code}
                                </Typography>} />)
                        )}
                    </FormGroup>
                </Grid>
                <Grid item id="Item-EmailAddress" sx={{ mb: -1}}>
                    <Divider sx={{mt: '16px', mb: '10px'}} />
                    <Grid container direction='row' spacing={2} columns={10}>
                        <Grid item id="Item-Email-Label" xs={2}>
                            <Typography component='span' >Contact emailadres:</Typography>
                        </Grid>
                        <Grid item id="Item-Email-Value" xs={8}>
                            <Typography component='span' color="text.disabled" >{eventctx.event.email}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item id="Item-EmailText">
                    <TextField
                        id="Input-EmailText"
                        name="emailText"
                        label="Extra tekst in email"
                        type="text"
                        multiline
                        rows={3}
                        InputProps={{ style: { fontSize: '15px' } }}
                        value={formValues.emailText}
                        onChange={handleInputChange}
                        sx={{ width: '80%', backgroundColor: 'common.white'}}
                    />
                </Grid>
                <Grid item id="Item-emailSignature">
                    <TextField
                        id="Input-emailSignature"
                        name="emailSignature"
                        label="Email ondertekening"
                        type="text"
                        required
                        InputProps={{ style: { fontSize: '15px' } }}
                        InputLabelProps={{ style: { fontSize: '15px' } }}
                        value={formValues.emailSignature}
                        onChange={handleInputChange}
                        sx={{ width: '50%', backgroundColor: 'common.white'}}
                    />
                </Grid>
                <Grid item sx={{marginTop: '10px'}}>
                    <Divider sx={{mt: '10px', mb: '30px'}} />
                    <Button id="SubmitButton" variant="contained" sx={{ fontWeight: 'bold', width: '20%'}} disabled={(!formValues.name || !formValues.location || !formValues.date)} type="submit" color='secondary' >Submit</Button>
                </Grid>
            </Grid>
        </Box>
        </ThemeProvider>
    )
}

export default EventUpdate;